module.exports = __webpack_public_path__ + "img/sale.b5787b12.png";